import {CommonStyleFn} from "./types";

type SvgParams = {
  fillColor: string;
  strokeColor: string;
  strokeWidth: number;
  fillRule: string;
  cssStyles: string;
};

const buildSvgIcon = (icon: string): string =>
  `%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E${icon}%3C%2Fsvg%3E%0A%0A%0A`;

const buildSvgPath = (path: string, params: SvgParams): string =>
  `%0A%0A%3Cpath%20d%3D%22${path}%22%20fill%3D%22${params.fillColor}%22%20fill-rule%3D%22${params.fillRule}%22%20stroke%3D%22${params.strokeColor}%22%20stroke-width%3D%22${params.strokeWidth}%22%20style%3D%22${params.cssStyles}%22%20%2F%3E`;

const sanatizeHexColor = (hexColor: string): string =>
  hexColor.replace("#", "%23");

const getImage = (
  fillColor: string,
  strokeColor = "transparent",
  strokeWidth = 0,
  fillRule = "nonzero",
  cssStyles = ""
): string => {
  const params = {
    fillColor,
    strokeColor,
    strokeWidth,
    fillRule,
    cssStyles,
  };
  const checkMark = buildSvgPath(
    "M11.884 0L4.091 7.793.858 4.61 0 5.467l4.088 4.026.01-.01.009.01L12.74.857z",
    params
  );
  const svgIcon = buildSvgIcon(checkMark);
  return `url("data:image/svg+xml;charset=utf8,${svgIcon}")`;
};

export const getCheckmarkSVG: CommonStyleFn<string> = ({theme}) =>
  getImage(sanatizeHexColor(theme.color.wh));
